import { EndorsementPremiumChange } from '@domain/schemas/endorsement-premium-change';
import type { EndorsementData } from '@domain/types/entity';

import type { EndorsementFormState } from '../types';

// Narrowed to just the fields read below: get-initial-values passes a fully-hydrated
// EndorsementData (edit mode, from the entity store), while EndorsementSelectionStep passes a
// bare DbEndorsement row (the duplicate-source list endpoint doesn't include sections/comments/
// audit_log) - both satisfy this narrower shape.
type EndorsementValueSource = Pick<
  EndorsementData,
  | 'additional_premium'
  | 'effective_date'
  | 'expiry_date'
  | 'internal_description'
  | 'premium_change'
  | 'reason'
  | 'reference'
  | 'type'
>;

/**
 * Basic Info / Reason & Premium fields, shared by edit-mode prefill (get-initial-values)
 * and by picking a source endorsement to duplicate (EndorsementSelectionStep) - both cases
 * populate a new/edited endorsement's details from an existing endorsement record.
 */
export function getValuesFromEndorsement(entity: EndorsementValueSource): Partial<EndorsementFormState> {
  return {
    additional_premium: entity.additional_premium,
    effective_date: entity.effective_date,
    expiry_date: entity.expiry_date,
    internal_description: entity.internal_description,
    premium_change: entity.premium_change || EndorsementPremiumChange.NONE,
    // The DB model stores reason/type as plain strings; the form narrows them to the enum options.
    reason: entity.reason as EndorsementFormState['reason'],
    reference: entity.reference,
    type: entity.type as EndorsementFormState['type'],
  };
}
